var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-dialog"},[_c('span',{on:{"click":function($event){return _vm.openDialog()}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }